import styled from 'styled-components';

export const PaginationContainer = styled.div`
  align-items: center;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px;
`;

export const PaginationNavigation = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: center;
  width: 100%;
`;

export const PaginationBtnContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const BtnContainer = styled.div``;

export const PageInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;

  span {
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
  }
`;

export const PageInput = styled.input`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: white;
  padding: 6px 0;
  width: 40px;
  text-align: center;
  font-size: 12px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #667eea;
    background: rgba(255, 255, 255, 0.15);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const LoadingIndicator = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-style: italic;
`;
